<template>
  <div v-loading="isDataLoading">
    <el-row class="panel-main">
      <el-col :span="16" class="panel-left">
        <div v-if="showBack" class="panel-title">
          <el-button type="text" icon="el-icon-arrow-left" @click="onBack">返回</el-button>
        </div>
        <div class="panel-content cs-fullHeight">
          <el-row>
            <el-col>
              <studentInfo :dataIn="studentInfoDataIn" />
            </el-col>
          </el-row>
          <el-row v-if="saWorkflow.IsCompleted">
            <el-col>
              <workflowServiceCard v-for="(service, index) in saWorkflow.ServiceList" :key="index"
                :isReadonly="!canRefund" :dataIn="service" @reload="onReload" />
            </el-col>
          </el-row>
        </div>
      </el-col>
      <el-col :span="8" class="panel-right">
        <div class="panel-title backgroud-gray-popup">
          <h5>收费信息</h5>
        </div>
        <div class="panel-content cs-fullHeight">
          <el-row v-if="saWorkflow.IsCompleted">
            <el-col v-for="(service, index) in saWorkflow.ServiceList" :key="index">
              <el-row>
                <el-col :span="17">
                  <h6><b>{{service.ServiceName}}</b></h6>
                </el-col>
                <el-col :span="7" class="align-right">
                  <span>{{service.SaleAmount|toCurrency(saWorkflow.Currency)}}</span>
                </el-col>
              </el-row>
              <el-row class="discount-amount">
                <el-col :span="17">
                  <span>折扣优惠</span>
                </el-col>
                <el-col :span="7" class="align-right">
                  <span>-{{service.DiscountAmount|toCurrency(saWorkflow.Currency)}}</span>
                </el-col>
              </el-row>
              <el-row class="discount-amount">
                <el-col :span="17">
                  <span>现金减</span>
                </el-col>
                <el-col :span="7" class="align-right">
                  <span>-{{service.CashDecreasedAmount|toCurrency(saWorkflow.Currency)}}</span>
                </el-col>
              </el-row>
              <el-row>
                <el-divider />
              </el-row>
            </el-col>
            <el-col>
              <el-row>
                <el-col :span="17">
                  <h6><b>手续费</b></h6>
                </el-col>
                <el-col :span="7" class="align-right">
                  <span>{{saWorkflow.PaymentServiceCharge|toCurrency(saWorkflow.Currency)}}</span>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="17">
                  <h6><b>总计</b></h6>
                </el-col>
                <el-col :span="7" class="align-right">
                  <span>{{saWorkflow.SaleAmountDiscounted|toCurrency(saWorkflow.Currency)}}</span>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="17">
                  <h6><b>已支付</b></h6>
                </el-col>
                <el-col :span="7" class="align-right">
                  <span>-{{saWorkflow.PaymentAmount|toCurrency(saWorkflow.Currency)}}</span>
                </el-col>
              </el-row>
              <el-row class="cs-redLabel">
                <el-col :span="17">
                  <h6><b>待支付</b></h6>
                </el-col>
                <el-col :span="7" class="align-right">
                  <span>{{saWorkflow.SaleAmountDiscounted - saWorkflow.PaymentAmount |toCurrency(saWorkflow.Currency)}}</span>
                </el-col>
              </el-row>
              <el-row v-if="!!saWorkflow.RefundAmount" class="cs-redLabel">
                <el-col :span="17">
                  <h6><b>退款</b></h6>
                </el-col>
                <el-col :span="7" class="align-right">
                  <span>-{{saWorkflow.RefundAmount|toCurrency(saWorkflow.Currency)}}</span>
                </el-col>
              </el-row>
              <el-row>
                <el-divider />
              </el-row>
            </el-col>
          </el-row>
          <el-row>
            <accountInfo displayType="simple" :isReadonly="isReadonly" :payeeTypeEditable="payeeTypeEditable" :disabledRemove="true"
              :workMode="'ContinuePayment'" :dataIn="accountInfoDataIn" @savePaymentEnd="onSavePaymentEnd" />
          </el-row>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {
  getStudyAbroadStudent,
  getSAStudentWorkflow,
  getSAStudentWorkflowByAccountId,
} from "@/service/studyAbroad.service";

const defaultSAStudent = {
  StudentId: 0,
  StudentName: null,
  Phone: null,
  SaleAmountDiscountedCAD: 0,
  SaleAmountDiscountedCNY: 0,
  SaleAmountAvailableCAD: 0,
  SaleAmountAvailableCNY: 0,
  WorkflowCurrencyList: [],
  ChannelId: null,
  ChannelName: null,
  ChannelCurrency: null,
};

const defaultSAWorkflow = {
  Id: 0,
  StudentId: 0,
  AccountId: null,
  CurrentStep: 0,
  PayeeType: null,
  IsPaymentReceived: false,
  IsCompleted: false,
  CompletedTime: null,
  ServiceList: [],
  Currency: 0,
};

export default {
  name: "accountProfile",
  components: {
    studentInfo: () => import("@/components/studyAbroad/studentInfo"),
    workflowServiceCard: () => import("./workflowServiceCard"),
    accountInfo: () => import("./accountInfo"),
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    showBack: {
      type: Boolean,
      default: true,
    },
    dataIn: {
      workflowId: {
        type: [Number, String],
        default: 0,
      },
      account: {
        type: Object,
        default: () => null,
      },
    },
  },
  data() {
    return {
      isDataLoading: false,
      dataChanged: false,
      saStudent: Object.clone(defaultSAStudent),
      studentInfoDataIn: {
        studentId: 0,
        studentData: null,
      },
      saWorkflow: Object.clone(defaultSAWorkflow),
      accountInfoDataIn: {
        studentId: 0,
        workflowId: 0,
        currency: 0,
        accountAmount: 0,
        model: null,
      },

      isReadonly: !this.USERMANAGER.isAdmin && !this.USERMANAGER.isSAManager,
      payeeTypeEditable: this.USERMANAGER.isAdmin || !this.USERMANAGER.isSAFinancialManager,
      paymentEditable: this.USERMANAGER.isAdmin || this.USERMANAGER.isSAManager,
      canRefund: this.USERMANAGER.isAdmin || this.USERMANAGER.isSAManager,
    };
  },
  created() {
    this.reloadData();
  },
  computed: {

  },
  methods: {
    // 与服务端数据交互相关方法
    async loadSAStudentFromServer(studentId, workflowId) {
      if (!studentId) {
        return;
      }

      this.isDataLoading = true;
      let result = await getStudyAbroadStudent(studentId, workflowId);
      this.saStudent =
        !!result && result.success && !!result.data
          ? result.data
          : Object.clone(defaultSAStudent);
      this.isDataLoading = false;
    },
    async loadSAStudentWorkflowFromServer() {
      if (!this.dataIn.account && !this.dataIn.workflowId) {
        return;
      }

      this.isDataLoading = true;
      let result;
      if (!!this.dataIn.account)
        result = await getSAStudentWorkflowByAccountId(this.dataIn.account.Id);
      else result = await getSAStudentWorkflow(this.dataIn.workflowId);
      this.saWorkflow =
        !!result && result.success && !!result.data
          ? result.data
          : Object.clone(defaultSAWorkflow);
      this.isDataLoading = false;
    },

    async reloadData() {
      this.dataChanged = false;
      await this.loadSAStudentWorkflowFromServer();

      let studentId = this.saWorkflow.StudentId;
      let workflowId = this.saWorkflow.Id;
      await this.loadSAStudentFromServer(studentId, workflowId);
    },

    onBack() {
      let isReload = this.dataChanged;
      this.$emit("close", isReload);
      this.dataChanged = false;
    },

    // studentInfo相关方法
    resetStudentInfoDataIn() {
      let studentData =
        !!this.saStudent && !!this.saStudent.StudentId ? this.saStudent : null;

      this.studentInfoDataIn = {
        studentId: !!studentData
          ? studentData.StudentId
          : this.saWorkflow.StudentId,
        studentData: studentData,
      };
    },

    // accountInfo相关方法
    resetAccountInfoDataIn() {
      let workflowData =
        !!this.saWorkflow && !!this.saWorkflow.Id ? this.saWorkflow : null;
      let studentData =
        !!this.saStudent && !!this.saStudent.StudentId ? this.saStudent : null;

      let currency = this.GLOBAL.currencyType.CNY;
      if (!!workflowData) currency = workflowData.Currency;
      else if (!!studentData) currency = studentData.ChannelCurrency;

      this.accountInfoDataIn = {
        studentId: !!workflowData
          ? workflowData.StudentId
          : this.dataIn.studentId,
        workflowId: !!workflowData ? workflowData.Id : this.dataIn.workflowId,
        currency: currency,
        payeeType:
          !!workflowData && !!workflowData.PayeeType
            ? workflowData.PayeeType
            : this.GLOBAL.enumPayeeType.Speedup,
        accountAmount: !!workflowData ? workflowData.SaleAmountDiscounted : 0,
        model: {
          paymentReceived:
            !!workflowData && workflowData.IsPaymentReceived ? 1 : 0,
          businessType: !!workflowData ? workflowData.BusinessType : 0,
          payeeType: !!workflowData ? workflowData.PayeeType : 0,
        },
      };
    },
    onSavePaymentEnd() {
      this.loadSAStudentWorkflowFromServer();
      this.dataChanged = true;
    },
    onReload() {
      this.reloadData();
      this.dataChanged = true;
    },
  },
  watch: {
    isLoading(newValue) {
      this.isDataLoading = this.isLoading;
    },
    dataIn(newValue) {
      this.reloadData();
    },
    saStudent(newValue) {
      this.resetStudentInfoDataIn();
    },
    saWorkflow(newValue) {
      this.resetAccountInfoDataIn();
    },
  },
};
</script>

<style lang="scss" scoped>
.panel-main {
  display: flex;
}

.panel-left {
  flex: 2;
}

.panel-right {
  flex: 1;
  border-left: 1px solid rgb(227, 227, 227);

  .discount-amount {
    color: grey;
  }
}

.panel-title {
  padding: 20px 40px 20px 40px;
  min-height: 81px;

  h5 {
    margin-bottom: 0;
    line-height: inherit;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/studyAbroad/accountProfile.vue